// this file is automatically generated by git.version.ts script
export const versions = {
  version: '0.17.11',
  revision: '8560cce3',
  branch: 'develop'
};